import { Component, input } from '@angular/core';
import { CurrencyDto } from '@workspace/data-types';

@Component({
  selector: 'aura-internationalization-currency-display',
  templateUrl: './internationalization-currency-display.component.html',
  imports: [],
})
export class AuraInternationalizationCurrencyDisplayComponent {
  currentCurrency = input<CurrencyDto | null>(null);
}
